import { createPercentSchema } from "./base"

export const targetTotalRiskSchema = createPercentSchema({ min: 0 })
  .refine(
    (value) => value !== "",
    { message: "Must have a value" },
  )
  .optional()
